import TextCell from './TextCell';

export default TextCell;
